import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { ErrorNote, Loading, Page } from "./common";

const CARD: React.CSSProperties = { background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "14px 18px" };

function Tile({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div style={CARD}>
      <div style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: "1px", textTransform: "uppercase", color: "#8a8e88" }}>{label}</div>
      <div style={{ fontFamily: "'Space Mono',monospace", fontSize: 26, fontWeight: 600, marginTop: 4 }}>{value}</div>
      {sub && <div style={{ fontSize: 11.5, color: "#8a8e88", marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

export function Reports() {
  const { data, isLoading, error } = useQuery({ queryKey: ["reports"], queryFn: api.reports });
  if (isLoading) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  const r = data!;
  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>Reports</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Created vs solved, CSAT, and volume by client and channel — computed live from the ticket store.</div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: 12 }}>
        <Tile label="Total tickets" value={String(r.totals.total)} />
        <Tile label="Open" value={String(r.totals.open)} />
        <Tile label="Solved" value={String(r.totals.solved)} />
        <Tile label="CSAT" value={r.csat.average == null ? "—" : r.csat.average.toFixed(2)} sub={`${r.csat.responses} response${r.csat.responses === 1 ? "" : "s"}`} />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))", gap: 16 }}>
        <div style={CARD}>
          <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>By client</div>
          {r.byClient.length === 0 ? (
            <div style={{ color: "#8a8e88", fontSize: 13 }}>No tickets yet.</div>
          ) : (
            r.byClient.map((c) => (
              <div key={c.clientId} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderTop: "1px solid #f4f3ee", fontSize: 12.5 }}>
                <span style={{ fontWeight: 500 }}>{c.clientId}</span>
                <span style={{ color: "#8a8e88" }}>{c.open} open · {c.total} total</span>
              </div>
            ))
          )}
        </div>
        <div style={CARD}>
          <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>By channel</div>
          {r.byChannel.length === 0 ? (
            <div style={{ color: "#8a8e88", fontSize: 13 }}>No tickets yet.</div>
          ) : (
            r.byChannel.map((c) => (
              <div key={c.channel} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderTop: "1px solid #f4f3ee", fontSize: 12.5 }}>
                <span style={{ fontWeight: 500 }}>{c.channel}</span>
                <span style={{ color: "#8a8e88" }}>{c.count}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </Page>
  );
}
